'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'house-flood-water';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e50e';
var svgPathData = 'M330.5 4c-6-5.3-15-5.3-21.1 0l-192 168c-6.7 5.8-7.3 15.9-1.5 22.6s15.9 7.3 22.6 1.5l5.5-4.8 0 129.1c10.4-3.6 21.2-6 32-7.3l0-149.8 144-126 144 126 0 149.8c10.8 1.3 21.6 3.7 32 7.3l0-129.1 5.5 4.8c6.6 5.8 16.8 5.1 22.6-1.5s5.1-16.8-1.5-22.6L330.5 4zM264 200l0 48c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32l0-48c0-17.7-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32zm32 0l48 0 0 48-48 0 0-48zM489.1 405.9c19.7 14.1 42.4 26.9 67 31.6 25.2 4.8 51.7 .9 77.2-17.4 7.2-5.1 8.9-15.1 3.7-22.3s-15.1-8.9-22.3-3.7c-18 12.8-35.4 15.3-52.6 12-17.9-3.4-36.2-13.2-54.4-26.2-37.1-26.5-87.1-26.5-124.3 0-25.3 18.1-45.3 28.1-63.5 28.1s-38.1-10.1-63.5-28.1c-37.1-26.5-87.1-26.5-124.3 0-23.2 16.5-46.1 27.7-68.2 27.5-12.5-.1-25.4-3.7-38.8-13.3-7.2-5.1-17.2-3.5-22.3 3.7S-.5 415 6.7 420.1c18.7 13.3 38 19.2 57.2 19.3 32.4 .2 62.2-15.8 86.9-33.5 26-18.6 61.1-18.6 87.1 0 25.6 18.3 52.9 34.1 82 34.1s56.4-15.8 82-34.1c26-18.6 61.1-18.6 87.1 0zm-87.1 96c26-18.6 61.1-18.6 87.1 0 19.7 14.1 42.4 26.9 67 31.6 25.2 4.8 51.7 .9 77.2-17.4 7.2-5.1 8.9-15.1 3.7-22.3s-15.1-8.9-22.3-3.7c-18 12.8-35.4 15.3-52.6 12-17.9-3.4-36.2-13.2-54.4-26.2-37.1-26.5-87.1-26.5-124.3 0-25.3 18.1-45.3 28.1-63.5 28.1s-38.1-10.1-63.5-28.1c-37.1-26.5-87.1-26.5-124.3 0-23.2 16.5-46.1 27.7-68.2 27.5-12.5-.1-25.4-3.7-38.8-13.3-7.2-5.1-17.2-3.5-22.3 3.7S-.5 511 6.7 516.1c18.7 13.3 38 19.2 57.2 19.3 32.4 .2 62.2-15.8 86.9-33.5 26-18.6 61.1-18.6 87.1 0 25.6 18.3 52.9 34.1 82 34.1s56.4-15.8 82-34.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHouseFloodWater = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;